import { trackEvent as trackAmplitudeEvent } from 'app/utils/analytics/amplitude/tracker';
import { trackEvent as trackRecordRelayEvent } from 'app/utils/analytics/recordrelay/tracker';
import type { HyroxEventName, HyroxEvents } from 'app/utils/analytics/types';

export const trackEvent = <T extends HyroxEventName>(name: T, props: HyroxEvents[T]): void => {
  trackAmplitudeEvent(name, props);
  trackRecordRelayEvent(name, props);
};
